import { type PillarFormInputComponentConfig } from "shared/components/pillar-form/PillarFormInputComponentConfig";

/**
 * True when a surveyjs-like config element should render as a select menu.
 *
 * Matches any `type` containing "select" (e.g. "select", "tagbox-select"),
 * the surveyjs "dropdown" type, or an explicit `inputType` of "select".
 */
export const isDynamicSelectInput = (
  element: PillarFormInputComponentConfig,
): boolean => {
  const type = String(element.type || "").toLowerCase();
  const inputType = String(element.inputType || "").toLowerCase();

  return (
    type.includes("select") || type === "dropdown" || inputType === "select"
  );
};
